import { transformRoutes } from '../utils'

export const BaseCustomerAreaRoutes = {
  route: '/customers',
  List: {
    route: '',
    DeletionPending: {
      route: '/deletion-pending',
    },
  },
  /**@deprecated use '/:customerTenant/:customerId' route instead*/
  Show: {
    route: '/customer/:customerId',
    Trips: {
      route: '/trips',
    },
    ListPackageContracts: {
      route: '/package-contract',
    },
    Referrals: {
      route: '/referrals',
    },
    Claims: {
      route: '/claims',
    },
  },
  Detail: {
    route: '/:customerTenant/:customerId',
    Trips: {
      route: '/trips',
    },
    ListPackageContracts: {
      route: '/package-contract',
    },
    Referrals: {
      route: '/referrals',
    },
    Claims: {
      route: '/claims',
    },
  },
}

export const CustomerAreaRoutes = transformRoutes(BaseCustomerAreaRoutes)
